import { createSlice } from "@reduxjs/toolkit";
import { IReportSlice } from "../../../models/master/reports";


const initialReportState: IReportSlice = {
  reports:undefined,
  report:undefined,
  dailyreports:undefined,
  monthlyreport:undefined,
  yearlyreports:undefined
};

const reportSlice = createSlice({
  name: "report",
  initialState: initialReportState,
  reducers: {
    setReports: (state, action: { payload: any }) => {
      state.reports = action.payload;
    },
    setReportsDaily: (state, action: { payload: any }) => {
      state.dailyreports = action.payload;
    },
    setReportsMonthly: (state, action: { payload: any }) => {
      state.monthlyreports = action.payload;
    },
    setReportsYearly: (state, action: { payload: any }) => {
      state.yearlyreports = action.payload;
    },
    setReport: (state, action: { payload: any }) => {
      state.report = action.payload;
    },
    
  },
});

export const { setReports, setReportsDaily, setReportsMonthly, setReportsYearly, setReport } =
reportSlice.actions;

const reportReducer = reportSlice.reducer;

export type reportState = ReturnType<typeof reportReducer>;

export default reportReducer;
